import React from 'react';
import { Switch, Route, Redirect} from 'react-router-dom';

import Footer from 'components/common/Footer';
import MessageBox from 'components/common/MessageBox';

const Content = props => (
	<div className="main">
		<Switch>
			{props.submenus.map((item, index) => (
				<Route path={item.path} component={item.component} key={index}/>
			))}
			<Redirect exact path={["/","/index.html"]} to="/license"/>
		</Switch>
		<MessageBox/>
		<Footer/>
	</div>
	
)

export default Content